import {
  LIST_COMPANY_VEHICLES,
  LIST_COMPANY_VEHICLES_SUCCESS,
  LIST_COMPANY_VEHICLES_FAILURE,
  CREATE_COMPANY_VEHICLE,
  CREATE_COMPANY_VEHICLE_SUCCESS,
  CREATE_COMPANY_VEHICLE_FAILURE,
  UPDATE_COMPANY_VEHICLE,
  UPDATE_COMPANY_VEHICLE_SUCCESS,
  UPDATE_COMPANY_VEHICLE_FAILURE,
  DELETE_COMPANY_VEHICLE,
  DELETE_COMPANY_VEHICLE_SUCCESS,
  DELETE_COMPANY_VEHICLE_FAILURE,
  GET_COMPANY_VEHICLE_DETAILS,
  GET_COMPANY_VEHICLE_DETAILS_SUCCESS,
  GET_COMPANY_VEHICLE_DETAILS_FAILURE,
  COMPANY_VEHICLE_SEARCH,
  COMPANY_VEHICLE_SEARCH_SUCCESS,
  COMPANY_VEHICLE_SEARCH_FAILURE,
  COMPANY_VEHICLE_STATUS_LIST,
  COMPANY_VEHICLE_STATUS_LIST_SUCCESS,
  COMPANY_VEHICLE_STATUS_LIST_FAILURE,
  COMPANY_VEHICLE_STATUS_CREATE,
  COMPANY_VEHICLE_STATUS_CREATE_SUCCESS,
  COMPANY_VEHICLE_STATUS_CREATE_FAILURE,
  COMPANY_VEHICLE_STATUS_UPDATE,
  COMPANY_VEHICLE_STATUS_UPDATE_SUCCESS,
  COMPANY_VEHICLE_STATUS_UPDATE_FAILURE,
  COMPANY_VEHICLE_STATUS_DELETE,
  COMPANY_VEHICLE_STATUS_DELETE_SUCCESS,
  COMPANY_VEHICLE_STATUS_DELETE_FAILURE,
  COMPANY_VEHICLE_TYPE_LIST,
  COMPANY_VEHICLE_TYPE_LIST_SUCCESS,
  COMPANY_VEHICLE_TYPE_LIST_FAILURE,
  COMPANY_VEHICLE_TYPE_CREATE,
  COMPANY_VEHICLE_TYPE_CREATE_SUCCESS,
  COMPANY_VEHICLE_TYPE_CREATE_FAILURE,
  COMPANY_VEHICLE_TYPE_UPDATE,
  COMPANY_VEHICLE_TYPE_UPDATE_SUCCESS,
  COMPANY_VEHICLE_TYPE_UPDATE_FAILURE,
  COMPANY_VEHICLE_TYPE_DELETE,
  COMPANY_VEHICLE_TYPE_DELETE_SUCCESS,
  COMPANY_VEHICLE_TYPE_DELETE_FAILURE,
  COMPANY_VEHICLE_CHECK_TYPE_LIST,
  COMPANY_VEHICLE_CHECK_TYPE_LIST_SUCCESS,
  COMPANY_VEHICLE_CHECK_TYPE_LIST_FAILURE,
  COMPANY_VEHICLE_CHECK_TYPE_CREATE,
  COMPANY_VEHICLE_CHECK_TYPE_CREATE_SUCCESS,
  COMPANY_VEHICLE_CHECK_TYPE_CREATE_FAILURE,
  COMPANY_VEHICLE_CHECK_TYPE_UPDATE,
  COMPANY_VEHICLE_CHECK_TYPE_UPDATE_SUCCESS,
  COMPANY_VEHICLE_CHECK_TYPE_UPDATE_FAILURE,
  COMPANY_VEHICLE_CHECK_TYPE_DELETE,
  COMPANY_VEHICLE_CHECK_TYPE_DELETE_SUCCESS,
  COMPANY_VEHICLE_CHECK_TYPE_DELETE_FAILURE,
  COMPANY_VEHICLE_CHECK_LIST,
  COMPANY_VEHICLE_CHECK_LIST_SUCCESS,
  COMPANY_VEHICLE_CHECK_LIST_FAILURE,
  COMPANY_VEHICLE_CHECK_CREATE,
  COMPANY_VEHICLE_CHECK_CREATE_SUCCESS,
  COMPANY_VEHICLE_CHECK_CREATE_FAILURE,
  COMPANY_VEHICLE_CHECK_UPDATE,
  COMPANY_VEHICLE_CHECK_UPDATE_SUCCESS,
  COMPANY_VEHICLE_CHECK_UPDATE_FAILURE,
  COMPANY_VEHICLE_CHECK_DELETE,
  COMPANY_VEHICLE_CHECK_DELETE_SUCCESS,
  COMPANY_VEHICLE_CHECK_DELETE_FAILURE,
  COMPANY_VEHICLE_TO_STAFF_LIST,
  COMPANY_VEHICLE_TO_STAFF_LIST_SUCCESS,
  COMPANY_VEHICLE_TO_STAFF_LIST_FAILURE,
  COMPANY_VEHICLE_TO_STAFF_CREATE,
  COMPANY_VEHICLE_TO_STAFF_CREATE_SUCCESS,
  COMPANY_VEHICLE_TO_STAFF_CREATE_FAILURE,
  COMPANY_VEHICLE_TO_STAFF_UPDATE,
  COMPANY_VEHICLE_TO_STAFF_UPDATE_SUCCESS,
  COMPANY_VEHICLE_TO_STAFF_UPDATE_FAILURE,
  COMPANY_VEHICLE_TO_STAFF_DELETE,
  COMPANY_VEHICLE_TO_STAFF_DELETE_SUCCESS,
  COMPANY_VEHICLE_TO_STAFF_DELETE_FAILURE,
  COMPANY_VEHICLE_TO_STAFF_SEARCH,
  COMPANY_VEHICLE_TO_STAFF_SEARCH_SUCCESS,
  COMPANY_VEHICLE_TO_STAFF_SEARCH_FAILURE,
  COMPANY_VEHICLE_CHECKOUT,
  COMPANY_VEHICLE_CHECKOUT_SUCCESS,
  COMPANY_VEHICLE_CHECKOUT_FAILURE,
  COMPANY_VEHICLE_CHECKIN,
  COMPANY_VEHICLE_CHECKIN_SUCCESS,
  COMPANY_VEHICLE_CHECKIN_FAILURE,
  COMPANY_VEHICLE_NOTE_LIST,
  COMPANY_VEHICLE_NOTE_LIST_SUCCESS,
  COMPANY_VEHICLE_NOTE_LIST_FAILURE,
  COMPANY_VEHICLE_NOTE_CREATE,
  COMPANY_VEHICLE_NOTE_CREATE_SUCCESS,
  COMPANY_VEHICLE_NOTE_CREATE_FAILURE,
  COMPANY_VEHICLE_NOTE_UPDATE,
  COMPANY_VEHICLE_NOTE_UPDATE_SUCCESS,
  COMPANY_VEHICLE_NOTE_UPDATE_FAILURE,
  COMPANY_VEHICLE_NOTE_DELETE,
  COMPANY_VEHICLE_NOTE_DELETE_SUCCESS,
  COMPANY_VEHICLE_NOTE_DELETE_FAILURE,
  COMPANY_VEHICLE_RECENT_ACTIVITY_LIST,
  COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS,
  COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_LIST,
  COMPANY_VEHICLE_GPS_TRACKER_LIST_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_LIST_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_CREATE,
  COMPANY_VEHICLE_GPS_TRACKER_CREATE_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_CREATE_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_UPDATE,
  COMPANY_VEHICLE_GPS_TRACKER_UPDATE_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_UPDATE_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_DELETE,
  COMPANY_VEHICLE_GPS_TRACKER_DELETE_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_DELETE_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES,
  COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_REFRESH,
  COMPANY_VEHICLE_GPS_TRACKER_REFRESH_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_REFRESH_FAILURE,
  COMPANY_VEHICLE_ATTACHMENT_SEARCH,
  COMPANY_VEHICLE_ATTACHMENT_SEARCH_SUCCESS,
  COMPANY_VEHICLE_ATTACHMENT_SEARCH_FAILURE,
  COMPANY_VEHICLE_ATTACHMENT_DELETE,
  COMPANY_VEHICLE_ATTACHMENT_DELETE_SUCCESS,
  COMPANY_VEHICLE_ATTACHMENT_DELETE_FAILURE,
} from "./actionType";

// List Company Vehicles
export const listCompanyVehicles = () => {
  return {
    type: LIST_COMPANY_VEHICLES,
  };
};

export const listCompanyVehiclesSuccess = (companyVehicles) => {
  return {
    type: LIST_COMPANY_VEHICLES_SUCCESS,
    payload: companyVehicles,
  };
};

export const listCompanyVehiclesFailure = (error) => {
  return {
    type: LIST_COMPANY_VEHICLES_FAILURE,
    payload: error,
  };
};

// Create Company Vehicle
export const createCompanyVehicle = (companyVehicle) => {
  return {
    type: CREATE_COMPANY_VEHICLE,
    payload: companyVehicle,
  };
};

export const createCompanyVehicleSuccess = (companyVehicle) => {
  return {
    type: CREATE_COMPANY_VEHICLE_SUCCESS,
    payload: companyVehicle,
  };
};

export const createCompanyVehicleFailure = (error) => {
  return {
    type: CREATE_COMPANY_VEHICLE_FAILURE,
    payload: error,
  };
};

// Update Company Vehicle
export const updateCompanyVehicle = (companyVehicle) => {
  return {
    type: UPDATE_COMPANY_VEHICLE,
    payload: companyVehicle,
  };
};

export const updateCompanyVehicleSuccess = (companyVehicle) => {
  return {
    type: UPDATE_COMPANY_VEHICLE_SUCCESS,
    payload: companyVehicle,
  };
};

export const updateCompanyVehicleFailure = (error) => {
  return {
    type: UPDATE_COMPANY_VEHICLE_FAILURE,
    payload: error,
  };
};

// Delete Company Vehicle
export const deleteCompanyVehicle = (id) => {
  return {
    type: DELETE_COMPANY_VEHICLE,
    payload: id,
  };
};

export const deleteCompanyVehicleSuccess = (id) => {
  return {
    type: DELETE_COMPANY_VEHICLE_SUCCESS,
    payload: id,
  };
};

export const deleteCompanyVehicleFailure = (error) => {
  return {
    type: DELETE_COMPANY_VEHICLE_FAILURE,
    payload: error,
  };
};

// Get Company Vehicle Details
export const getCompanyVehicleDetails = (id) => {
  return {
    type: GET_COMPANY_VEHICLE_DETAILS,
    payload: id,
  };
};

export const getCompanyVehicleDetailsSuccess = (companyVehicle) => {
  return {
    type: GET_COMPANY_VEHICLE_DETAILS_SUCCESS,
    payload: companyVehicle,
  };
};

export const getCompanyVehicleDetailsFailure = (error) => {
  return {
    type: GET_COMPANY_VEHICLE_DETAILS_FAILURE,
    payload: error,
  };
};

// Search Company Vehicle
export const searchCompanyVehicle = (search) => {
  return {
    type: COMPANY_VEHICLE_SEARCH,
    payload: search,
  };
};

export const searchCompanyVehicleSuccess = (companyVehicles) => {
  return {
    type: COMPANY_VEHICLE_SEARCH_SUCCESS,
    payload: companyVehicles,
  };
};

export const searchCompanyVehicleFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_SEARCH_FAILURE,
    payload: error,
  };
};

// List Company Vehicle Status
export const listCompanyVehicleStatus = () => {
  return {
    type: COMPANY_VEHICLE_STATUS_LIST,
  };
};

export const listCompanyVehicleStatusSuccess = (companyVehicleStatus) => {
  return {
    type: COMPANY_VEHICLE_STATUS_LIST_SUCCESS,
    payload: companyVehicleStatus,
  };
};

export const listCompanyVehicleStatusFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_STATUS_LIST_FAILURE,
    payload: error,
  };
};

// Create Company Vehicle Status
export const createCompanyVehicleStatus = (companyVehicleStatus) => {
  return {
    type: COMPANY_VEHICLE_STATUS_CREATE,
    payload: companyVehicleStatus,
  };
};

export const createCompanyVehicleStatusSuccess = (companyVehicleStatus) => {
  return {
    type: COMPANY_VEHICLE_STATUS_CREATE_SUCCESS,
    payload: companyVehicleStatus,
  };
};

export const createCompanyVehicleStatusFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_STATUS_CREATE_FAILURE,
    payload: error,
  };
};

// Update Company Vehicle Status
export const updateCompanyVehicleStatus = (companyVehicleStatus) => {
  return {
    type: COMPANY_VEHICLE_STATUS_UPDATE,
    payload: companyVehicleStatus,
  };
};

export const updateCompanyVehicleStatusSuccess = (companyVehicleStatus) => {
  return {
    type: COMPANY_VEHICLE_STATUS_UPDATE_SUCCESS,
    payload: companyVehicleStatus,
  };
};

export const updateCompanyVehicleStatusFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_STATUS_UPDATE_FAILURE,
    payload: error,
  };
};

// Delete Company Vehicle Status
export const deleteCompanyVehicleStatus = (id) => {
  return {
    type: COMPANY_VEHICLE_STATUS_DELETE,
    payload: id,
  };
};

export const deleteCompanyVehicleStatusSuccess = (id) => {
  return {
    type: COMPANY_VEHICLE_STATUS_DELETE_SUCCESS,
    payload: id,
  };
};

export const deleteCompanyVehicleStatusFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_STATUS_DELETE_FAILURE,
    payload: error,
  };
};

// List Company Vehicle Type
export const listCompanyVehicleType = () => {
  return {
    type: COMPANY_VEHICLE_TYPE_LIST,
  };
};

export const listCompanyVehicleTypeSuccess = (companyVehicleType) => {
  return {
    type: COMPANY_VEHICLE_TYPE_LIST_SUCCESS,
    payload: companyVehicleType,
  };
};

export const listCompanyVehicleTypeFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_TYPE_LIST_FAILURE,
    payload: error,
  };
};

// Create Company Vehicle Type
export const createCompanyVehicleType = (companyVehicleType) => {
  return {
    type: COMPANY_VEHICLE_TYPE_CREATE,
    payload: companyVehicleType,
  };
};

export const createCompanyVehicleTypeSuccess = (companyVehicleType) => {
  return {
    type: COMPANY_VEHICLE_TYPE_CREATE_SUCCESS,
    payload: companyVehicleType,
  };
};

export const createCompanyVehicleTypeFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_TYPE_CREATE_FAILURE,
    payload: error,
  };
};

// Update Company Vehicle Type
export const updateCompanyVehicleType = (companyVehicleType) => {
  return {
    type: COMPANY_VEHICLE_TYPE_UPDATE,
    payload: companyVehicleType,
  };
};

export const updateCompanyVehicleTypeSuccess = (companyVehicleType) => {
  return {
    type: COMPANY_VEHICLE_TYPE_UPDATE_SUCCESS,
    payload: companyVehicleType,
  };
};

export const updateCompanyVehicleTypeFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_TYPE_UPDATE_FAILURE,
    payload: error,
  };
};

// Delete Company Vehicle Type
export const deleteCompanyVehicleType = (id) => {
  return {
    type: COMPANY_VEHICLE_TYPE_DELETE,
    payload: id,
  };
};

export const deleteCompanyVehicleTypeSuccess = (id) => {
  return {
    type: COMPANY_VEHICLE_TYPE_DELETE_SUCCESS,
    payload: id,
  };
};

export const deleteCompanyVehicleTypeFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_TYPE_DELETE_FAILURE,
    payload: error,
  };
};

// List Company Vehicle Check Type
export const listCompanyVehicleCheckType = () => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_LIST,
  };
};

export const listCompanyVehicleCheckTypeSuccess = (companyVehicleCheckType) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_LIST_SUCCESS,
    payload: companyVehicleCheckType,
  };
};

export const listCompanyVehicleCheckTypeFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_LIST_FAILURE,
    payload: error,
  };
};

// Create Company Vehicle Check Type
export const createCompanyVehicleCheckType = (companyVehicleCheckType) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_CREATE,
    payload: companyVehicleCheckType,
  };
};

export const createCompanyVehicleCheckTypeSuccess = (
  companyVehicleCheckType
) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_CREATE_SUCCESS,
    payload: companyVehicleCheckType,
  };
};

export const createCompanyVehicleCheckTypeFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_CREATE_FAILURE,
    payload: error,
  };
};

// Update Company Vehicle Check Type
export const updateCompanyVehicleCheckType = (companyVehicleCheckType) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_UPDATE,
    payload: companyVehicleCheckType,
  };
};

export const updateCompanyVehicleCheckTypeSuccess = (
  companyVehicleCheckType
) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_UPDATE_SUCCESS,
    payload: companyVehicleCheckType,
  };
};

export const updateCompanyVehicleCheckTypeFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_UPDATE_FAILURE,
    payload: error,
  };
};

// Delete Company Vehicle Check Type
export const deleteCompanyVehicleCheckType = (id) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_DELETE,
    payload: id,
  };
};

export const deleteCompanyVehicleCheckTypeSuccess = (id) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_DELETE_SUCCESS,
    payload: id,
  };
};

export const deleteCompanyVehicleCheckTypeFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_CHECK_TYPE_DELETE_FAILURE,
    payload: error,
  };
};

// List Company Vehicle Checks (by vehicle)
export const listCompanyVehicleCheck = (id) => {
  return {
    type: COMPANY_VEHICLE_CHECK_LIST,
    payload: id,
  };
};

export const listCompanyVehicleCheckSuccess = (companyVehicleChecks) => {
  return {
    type: COMPANY_VEHICLE_CHECK_LIST_SUCCESS,
    payload: companyVehicleChecks,
  };
};

export const listCompanyVehicleCheckFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_CHECK_LIST_FAILURE,
    payload: error,
  };
};

// Create Company Vehicle Check
export const createCompanyVehicleCheck = (companyVehicleCheck) => {
  return {
    type: COMPANY_VEHICLE_CHECK_CREATE,
    payload: companyVehicleCheck,
  };
};

export const createCompanyVehicleCheckSuccess = (companyVehicleCheck) => {
  return {
    type: COMPANY_VEHICLE_CHECK_CREATE_SUCCESS,
    payload: companyVehicleCheck,
  };
};

export const createCompanyVehicleCheckFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_CHECK_CREATE_FAILURE,
    payload: error,
  };
};

// Update Company Vehicle Check
export const updateCompanyVehicleCheck = (companyVehicleCheck) => {
  return {
    type: COMPANY_VEHICLE_CHECK_UPDATE,
    payload: companyVehicleCheck,
  };
};

export const updateCompanyVehicleCheckSuccess = (companyVehicleCheck) => {
  return {
    type: COMPANY_VEHICLE_CHECK_UPDATE_SUCCESS,
    payload: companyVehicleCheck,
  };
};

export const updateCompanyVehicleCheckFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_CHECK_UPDATE_FAILURE,
    payload: error,
  };
};

// Delete Company Vehicle Check
export const deleteCompanyVehicleCheck = (id) => {
  return {
    type: COMPANY_VEHICLE_CHECK_DELETE,
    payload: id,
  };
};

export const deleteCompanyVehicleCheckSuccess = (id) => {
  return {
    type: COMPANY_VEHICLE_CHECK_DELETE_SUCCESS,
    payload: id,
  };
};

export const deleteCompanyVehicleCheckFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_CHECK_DELETE_FAILURE,
    payload: error,
  };
};

// List Company Vehicle To Staff (custody history by vehicle)
export const listCompanyVehicleToStaff = (id) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_LIST,
    payload: id,
  };
};

export const listCompanyVehicleToStaffSuccess = (companyVehicleToStaff) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_LIST_SUCCESS,
    payload: companyVehicleToStaff,
  };
};

export const listCompanyVehicleToStaffFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_LIST_FAILURE,
    payload: error,
  };
};

// Create Company Vehicle To Staff (permanent assignment)
export const createCompanyVehicleToStaff = (companyVehicleToStaff) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_CREATE,
    payload: companyVehicleToStaff,
  };
};

export const createCompanyVehicleToStaffSuccess = (companyVehicleToStaff) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_CREATE_SUCCESS,
    payload: companyVehicleToStaff,
  };
};

export const createCompanyVehicleToStaffFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_CREATE_FAILURE,
    payload: error,
  };
};

// Update Company Vehicle To Staff
export const updateCompanyVehicleToStaff = (companyVehicleToStaff) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_UPDATE,
    payload: companyVehicleToStaff,
  };
};

export const updateCompanyVehicleToStaffSuccess = (companyVehicleToStaff) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_UPDATE_SUCCESS,
    payload: companyVehicleToStaff,
  };
};

export const updateCompanyVehicleToStaffFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_UPDATE_FAILURE,
    payload: error,
  };
};

// Delete Company Vehicle To Staff
export const deleteCompanyVehicleToStaff = (id) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_DELETE,
    payload: id,
  };
};

export const deleteCompanyVehicleToStaffSuccess = (id) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_DELETE_SUCCESS,
    payload: id,
  };
};

export const deleteCompanyVehicleToStaffFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_DELETE_FAILURE,
    payload: error,
  };
};

// Search Company Vehicle To Staff (custody log across all vehicles)
export const searchCompanyVehicleToStaff = (searchData) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_SEARCH,
    payload: searchData,
  };
};

export const searchCompanyVehicleToStaffSuccess = (companyVehicleToStaff) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_SEARCH_SUCCESS,
    payload: companyVehicleToStaff,
  };
};

export const searchCompanyVehicleToStaffFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_TO_STAFF_SEARCH_FAILURE,
    payload: error,
  };
};

// Checkout Company Vehicle (pool car out) - single flat object
export const checkoutCompanyVehicle = (checkout) => {
  return {
    type: COMPANY_VEHICLE_CHECKOUT,
    payload: checkout,
  };
};

export const checkoutCompanyVehicleSuccess = (checkout) => {
  return {
    type: COMPANY_VEHICLE_CHECKOUT_SUCCESS,
    payload: checkout,
  };
};

export const checkoutCompanyVehicleFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_CHECKOUT_FAILURE,
    payload: error,
  };
};

// Checkin Company Vehicle (pool car back) - single flat object
export const checkinCompanyVehicle = (checkin) => {
  return {
    type: COMPANY_VEHICLE_CHECKIN,
    payload: checkin,
  };
};

export const checkinCompanyVehicleSuccess = (checkin) => {
  return {
    type: COMPANY_VEHICLE_CHECKIN_SUCCESS,
    payload: checkin,
  };
};

export const checkinCompanyVehicleFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_CHECKIN_FAILURE,
    payload: error,
  };
};

// List Company Vehicle Notes (by vehicle)
export const listCompanyVehicleNote = (id) => {
  return {
    type: COMPANY_VEHICLE_NOTE_LIST,
    payload: id,
  };
};

export const listCompanyVehicleNoteSuccess = (companyVehicleNotes) => {
  return {
    type: COMPANY_VEHICLE_NOTE_LIST_SUCCESS,
    payload: companyVehicleNotes,
  };
};

export const listCompanyVehicleNoteFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_NOTE_LIST_FAILURE,
    payload: error,
  };
};

// Create Company Vehicle Note
export const createCompanyVehicleNote = (companyVehicleNote) => {
  return {
    type: COMPANY_VEHICLE_NOTE_CREATE,
    payload: companyVehicleNote,
  };
};

export const createCompanyVehicleNoteSuccess = (companyVehicleNote) => {
  return {
    type: COMPANY_VEHICLE_NOTE_CREATE_SUCCESS,
    payload: companyVehicleNote,
  };
};

export const createCompanyVehicleNoteFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_NOTE_CREATE_FAILURE,
    payload: error,
  };
};

// Update Company Vehicle Note
export const updateCompanyVehicleNote = (companyVehicleNote) => {
  return {
    type: COMPANY_VEHICLE_NOTE_UPDATE,
    payload: companyVehicleNote,
  };
};

export const updateCompanyVehicleNoteSuccess = (companyVehicleNote) => {
  return {
    type: COMPANY_VEHICLE_NOTE_UPDATE_SUCCESS,
    payload: companyVehicleNote,
  };
};

export const updateCompanyVehicleNoteFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_NOTE_UPDATE_FAILURE,
    payload: error,
  };
};

// Delete Company Vehicle Note
export const deleteCompanyVehicleNote = (id) => {
  return {
    type: COMPANY_VEHICLE_NOTE_DELETE,
    payload: id,
  };
};

export const deleteCompanyVehicleNoteSuccess = (id) => {
  return {
    type: COMPANY_VEHICLE_NOTE_DELETE_SUCCESS,
    payload: id,
  };
};

export const deleteCompanyVehicleNoteFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_NOTE_DELETE_FAILURE,
    payload: error,
  };
};

// List Company Vehicle Recent Activity
export const listCompanyVehicleRecentActivity = (id) => {
  return {
    type: COMPANY_VEHICLE_RECENT_ACTIVITY_LIST,
    payload: id,
  };
};

export const listCompanyVehicleRecentActivitySuccess = (
  companyVehicleRecentActivity
) => {
  return {
    type: COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS,
    payload: companyVehicleRecentActivity,
  };
};

export const listCompanyVehicleRecentActivityFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_FAILURE,
    payload: error,
  };
};

// List Company Vehicle GPS Trackers (by vehicle) - id = { id: CompanyVehicle_Id }
export const listCompanyVehicleGpsTracker = (id) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_LIST,
    payload: id,
  };
};

export const listCompanyVehicleGpsTrackerSuccess = (gpsTrackers) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_LIST_SUCCESS,
    payload: gpsTrackers,
  };
};

export const listCompanyVehicleGpsTrackerFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_LIST_FAILURE,
    payload: error,
  };
};

// Create (assign) Company Vehicle GPS Tracker
export const createCompanyVehicleGpsTracker = (gpsTracker) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_CREATE,
    payload: gpsTracker,
  };
};

export const createCompanyVehicleGpsTrackerSuccess = (gpsTracker) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_CREATE_SUCCESS,
    payload: gpsTracker,
  };
};

export const createCompanyVehicleGpsTrackerFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_CREATE_FAILURE,
    payload: error,
  };
};

// Update Company Vehicle GPS Tracker
export const updateCompanyVehicleGpsTracker = (gpsTracker) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_UPDATE,
    payload: gpsTracker,
  };
};

export const updateCompanyVehicleGpsTrackerSuccess = (gpsTracker) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_UPDATE_SUCCESS,
    payload: gpsTracker,
  };
};

export const updateCompanyVehicleGpsTrackerFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_UPDATE_FAILURE,
    payload: error,
  };
};

// Delete (remove) Company Vehicle GPS Tracker - id = [Id, ...]
export const deleteCompanyVehicleGpsTracker = (id) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_DELETE,
    payload: id,
  };
};

export const deleteCompanyVehicleGpsTrackerSuccess = (id) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_DELETE_SUCCESS,
    payload: id,
  };
};

export const deleteCompanyVehicleGpsTrackerFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_DELETE_FAILURE,
    payload: error,
  };
};

// List GPSLive provider devices (for the assign dropdown)
export const listGpsLiveDevices = () => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES,
  };
};

export const listGpsLiveDevicesSuccess = (devices) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_SUCCESS,
    payload: devices,
  };
};

export const listGpsLiveDevicesFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_FAILURE,
    payload: error,
  };
};

// Refresh a tracker's live position - data = { id: CompanyVehicleGpsTracker_Id }
export const refreshCompanyVehicleGpsTracker = (data) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_REFRESH,
    payload: data,
  };
};

export const refreshCompanyVehicleGpsTrackerSuccess = (data) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_REFRESH_SUCCESS,
    payload: data,
  };
};

export const refreshCompanyVehicleGpsTrackerFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_GPS_TRACKER_REFRESH_FAILURE,
    payload: error,
  };
};

// Search Company Vehicle Attachments - data = [{ companyvehicleattachment_data: { CompanyVehicle_Id } }]
export const searchCompanyVehicleAttachment = (data) => {
  return {
    type: COMPANY_VEHICLE_ATTACHMENT_SEARCH,
    payload: data,
  };
};

export const searchCompanyVehicleAttachmentSuccess = (data) => {
  return {
    type: COMPANY_VEHICLE_ATTACHMENT_SEARCH_SUCCESS,
    payload: data,
  };
};

export const searchCompanyVehicleAttachmentFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_ATTACHMENT_SEARCH_FAILURE,
    payload: error,
  };
};

// Delete Company Vehicle Attachment - data = [Id, ...]
export const deleteCompanyVehicleAttachment = (data) => {
  return {
    type: COMPANY_VEHICLE_ATTACHMENT_DELETE,
    payload: data,
  };
};

export const deleteCompanyVehicleAttachmentSuccess = (data) => {
  return {
    type: COMPANY_VEHICLE_ATTACHMENT_DELETE_SUCCESS,
    payload: data,
  };
};

export const deleteCompanyVehicleAttachmentFailure = (error) => {
  return {
    type: COMPANY_VEHICLE_ATTACHMENT_DELETE_FAILURE,
    payload: error,
  };
};
